
$(function(){
	GLOBAL.content=$('body');
});


$(window).on('load', function () {
	GLOBAL.loaded=true;
	lazyImgLoad();
});


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
(function () {
	window.axios = require('axios');

	window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
})();

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
(function () {
	let csrfToken   = document.head.querySelector('meta[name="csrf-token"]');
	let bearerToken = document.head.querySelector('meta[name="bearer-token"]');

	if (csrfToken) {
		window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
	} else {
		console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
	}

	if (bearerToken) {
		window.axios.defaults.headers.common['Authorization'] = bearerToken.content;
	}
})();


/**
 * Afficher une sorte de "sous-input" dans une popover
 */
(function () {
	const $body = $('body');

	$('.sub-input__form-control').each(function () {
		const $popover      = $(this).parents('.sub-input').find('.sub-input__popover');
		let fnEventListened = null;

		$(this).on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			// Afficher la popover
			if (!$popover.hasClass('show')) {
				_displayPopover($popover, true);

				// Cacher la popover si clic au dehors
				fnEventListened = onClickOutside($popover, function ($el) {
					_displayPopover($popover, false);
				});
			}
		});

		// Cacher la popover si clic sur le bouton de fermeture
		$popover.find('.sub-input__close').on('click', function () {
			_displayPopover($popover, false);
			document.removeEventListener('click', fnEventListened);
		});


		$('.__js-sb-moment-radio, #input_moment_date').on('change', function () {
			const $radio = $(this);
			if ($radio.val() !== "custom")
				_displayPopover($popover, false);
			$('.js-backdrop').addClass('d-none').removeClass('backdrop--active');
			$('.js-trigger-backdrop').removeClass('before-backdrop');
		});
	});

	function _displayPopover ($popover, boolean = true) {
		if (boolean === true) {
			$popover.addClass('show');
			$body.addClass('sub-input-popover-show');
		} else {
			$popover.removeClass('show');
			$body.removeClass('sub-input-popover-show');
		}
	}
})();

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// window.Echo = require('laravel-echo');
// window.io = require('socket.io-client');
//
// window.Echo = new Echo({
// 	broadcaster: 'socket.io',
// 	host: window.location.hostname + ':' + process.env.MIX_LARAVEL_ECHO_PORT,
//	reconnectionAttempts: 5
// });

/*=======================================================*/

/*======================= FUNCTIONS =====================*/

/**
 * Cacher un élément lorsqu'un clic est effectué hors de celui-ci
 *
 * @param $el
 * @param callback
 *
 * @returns function outsideClickListener
 */
function onClickOutside ($el, callback,) {
	const outsideClickListener = (event) => {
		const $target = $(event.target);
		if (!$target.closest($el).length && $el.hasClass('show')) {
			callback($el);
			removeClickListener();
		}
	};

	const removeClickListener = () => {
		document.removeEventListener('click', outsideClickListener);
	};

	document.addEventListener('click', outsideClickListener);

	return outsideClickListener;
}


/**
 * Donner une impression d'override à des champs de formulaire
 */
window.editFormDefaultValues = function ($el) {
	const $default       = $el.find('.js-efdv-default'),
		  $editBtn       = $el.find('.js-efdv-edit-btn'),
		  $edit          = $el.find('.js-efdv-edit'),
		  $cancelEditBtn = $el.find('.js-efdv-cancel-edit-btn'),
		  $input         = $el.find('.js-efdv-input');

	const defaultModeEvent = new Event("efdv:default"),
		  editModeEvent    = new Event("efdv:edit");

	const showEdition = $input.val() !== '' && $input.val() !== null;

	/**
	 * Afficher ou non le champ d'édition si le champ est vide
	 */
	if (showEdition) {
		showDefaultInfoEdit();
	} else {
		hideDefaultInfoEdit();
	}

	/**
	 * Afficher le champ d'édition
	 */
	function showDefaultInfoEdit () {
		$default.addClass('opacity-25');
		$default.css('pointer-events', 'none');
		$editBtn.addClass('d-none');
		$edit.removeClass('d-none');

		$el[0].dispatchEvent(defaultModeEvent);
	}

	/**
	 * Masquer le champ d'édition
	 */
	function hideDefaultInfoEdit () {
		$default.removeClass('opacity-25');
		$default.css('pointer-events', 'all');
		$editBtn.removeClass('d-none');
		$edit.addClass('d-none');
		$input.val('');

		$el[0].dispatchEvent(editModeEvent);
	}


	/**
	 * Afficher le champ d'édition au clique sur le bouton
	 */
	$editBtn.on('click', function () {
		showDefaultInfoEdit();
	});

	/**
	 * Masquer le champ d'édition au clique sur le bouton
	 */
	$cancelEditBtn.on('click', function () {
		hideDefaultInfoEdit($(this).attr('data-select'));
	});
}


/**
 * Gestion des images
 */
function lazyImgLoad(cont){
	if(cont===undefined){
		cont=GLOBAL.content;
	}
	$('.lazy-img',cont).each(function () {
		if(!$(this).data('lazyloaded') || GLOBAL.force_lazyload){
			GLOBAL.force_lazyload=false;

				var imgpath = $(this).data('src');

			var w=Math.ceil($(this).width()*window.devicePixelRatio);
			imgpath = imgpath.replace('_W',w);
			var h=Math.ceil($(this).height()*window.devicePixelRatio);
			imgpath = imgpath.replace('_H',h);

			if(w && h){
				if(GLOBAL.webp_support){
					imgpath=imgpath.replace('.jpg','.webp');
					imgpath=imgpath.replace('.png','.webp');
				}
				else if(GLOBAL.avif_support){
					imgpath=imgpath.replace('.jpg','.avif');
					imgpath=imgpath.replace('.png','.avif');
				}

				$(this).attr('src', imgpath);
				if($(this).data('customCssAnimation')){
					$(this).data('lazyloaded',true).parents('.custom-lazyload__container').addClass('lazyloaded');
				}else{
					$(this).css('opacity','0').fadeTo($(this).data('fade')||300,1);
				}


			}
		}

	});
}

